import React, { useEffect, useState } from 'react';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import styles from './reviewsHeaderStyles.module.scss';
import FitSlider from '../FitSlider';
import { StarsUI } from '../../Reviews';
import { useMediaQuery } from 'usehooks-ts';
import { fetchProductReviewsHeaderData } from 'src/scripts/utils/reviews';
import { ProductReviewSummaryResponse } from '../../../types/reviews';
import { pluralize } from 'src/scripts/utils/helpers';

const ReviewsHeader = ({
  productHandle,
  hasRatingsButNoReviews,
}: {
  productHandle: string;
  hasRatingsButNoReviews: boolean;
}) => {
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT);
  const [data, setData] = useState<ProductReviewSummaryResponse | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!productHandle) {
      setError(new Error('Product handle is not available'));
      return;
    }
    fetchProductReviewsHeaderData({ productHandle }).then(setData).catch(setError);
  }, [productHandle]);

  if (!data || error) return null;

  const { rating, total_reviews, fit } = data;
  const { rating: fitRating, range } = fit;
  const aloReviewsSummary = window?.server_pdp_data?.metaFields?.aloReviews?.['review-highlights'];

  return (
    <div className={styles.reviewsHeader}>
      <h3 className="h3 pb-lg notranslate">Reviews</h3>
      <div className={styles.reviewsHeaderColumns}>
        <div className={styles.reviewsRatingSummary}>
          <div className={styles.reviewsStars}>
            <h5 className="h5 notranslate">{Math.round(rating * 10) / 10} Stars</h5>
            <StarsUI score={rating} starSize={isMobile ? `30px` : `40px`} color="var(--highlight-medium)" />
          </div>
          <p className="body-large notranslate">
            {pluralize(total_reviews, hasRatingsButNoReviews ? `Rating` : `Review`)}
          </p>
        </div>
        {fit && !hasRatingsButNoReviews && (
          <div className={styles.reviewsFitSummary}>
            <h5 className="h5 notranslate">Size & Fit Average</h5>
            <FitSlider averageRating={fitRating} fitRange={range} />
          </div>
        )}
        {aloReviewsSummary && (
          <div className={styles.reviewsHighlightsSummary}>
            <h5 className="h5 notranslate">Review Highlights</h5>
            <p className="body notranslate">{aloReviewsSummary}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewsHeader;
